webpackJsonp([70144966829960],{

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(26);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(20);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactEmotion = __webpack_require__(17);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Contact = function (_Component) {
	  _inherits(Contact, _Component);
	
	  function Contact() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Contact);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      name: '',
	      email: '',
	      emailValid: false,
	      message: '',
	      submitted: false
	    }, _this.handleChange = function (event) {
	      var _this$setState;
	
	      var value = event.target.value;
	      var name = event.target.name;
	
	      if (name === 'email') {
	        if (/(^\w.*@\w+\.\w)/.test(value)) {
	          console.log('Valid email!');
	          _this.setState({
	            emailValid: true
	          });
	        } else {
	          console.log('Keep going...');
	          _this.setState({
	            emailValid: false
	          });
	        }
	      }
	
	      _this.setState((_this$setState = {}, _this$setState[name] = value, _this$setState));
	    }, _this.handleSubmit = function (event) {
	      fetch('/', {
	        method: 'POST',
	        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	        body: encode(_extends({ 'form-name': 'contact-form' }, _this.state))
	      }).then(function () {
	        console.log('Message sent successfully!');
	        return _this.setState({
	          submitted: true
	        });
	      }).catch(function (error) {
	        return alert(error);
	      });
	
	      event.preventDefault();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Contact.prototype.render = function render() {
	    var data = this.props.data;
	
	    return _react2.default.createElement(
	      'div',
	      { className: container },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Allexa D\'Alessio | ' + data.contentfulSitePage.name
	        )
	      ),
	      _react2.default.createElement(
	        Title,
	        { background: data.contentfulSitePage.background },
	        data.contentfulSitePage.name
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: content },
	        _react2.default.createElement(
	          'div',
	          { className: left },
	          _react2.default.createElement(
	            'p',
	            { className: left__question },
	            'Have a question? Send me a message!',
	            _react2.default.createElement('br', null),
	            ' For booking inquiries:'
	          ),
	          _react2.default.createElement(
	            'h3',
	            { className: header },
	            'Los Angeles'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: agency },
	            'Natural Models',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:amanda@naturalmodelsla.com?subject=Allexa%20D%27Alessio' },
	              'amanda@naturalmodelsla.com'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: agency },
	            'The Osbrink Agency (Commercial)',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:Libby@osbrinkagency.com?subject=Allexa%20D%27Alessio' },
	              'Libby@osbrinkagency.com'
	            )
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'h3',
	            { className: header },
	            'New York'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: agency },
	            'Wilhelmina Models',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:Jaime.Goldberg@wilhelmina.com?subject=Allexa%20D%27Alessio' },
	              'Jaime.Goldberg@wilhelmina.com'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: right },
	          this.state.submitted ? _react2.default.createElement(
	            'div',
	            { className: thanks },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'b',
	                null,
	                'Thanks so much for your message!'
	              ),
	              _react2.default.createElement('br', null),
	              'I\'ll get back to you soon.'
	            )
	          ) : _react2.default.createElement(
	            'form',
	            {
	              name: 'contact-form',
	              method: 'post',
	              onSubmit: this.handleSubmit,
	              'data-netlify': 'true',
	              'data-netlify-honeypot': 'bot-field'
	            },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'name' },
	              'Name'
	            ),
	            _react2.default.createElement('input', {
	              name: 'name',
	              value: this.state.name,
	              onChange: this.handleChange,
	              type: 'text',
	              autoComplete: 'name',
	              required: true
	            }),
	            _react2.default.createElement(
	              'label',
	              { className: hidden, htmlFor: 'bot-field' },
	              'Bots only'
	            ),
	            _react2.default.createElement('input', { className: hidden, name: 'bot-field', type: 'text' }),
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'email' },
	              'Email'
	            ),
	            _react2.default.createElement('input', {
	              name: 'email',
	              value: this.state.email,
	              onChange: this.handleChange,
	              type: 'text',
	              autoComplete: 'email',
	              required: true
	            }),
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'message' },
	              'Message'
	            ),
	            _react2.default.createElement('textarea', {
	              name: 'message',
	              value: this.state.message,
	              onChange: this.handleChange,
	              required: true
	            }),
	            _react2.default.createElement(
	              'button',
	              { disabled: !this.state.emailValid, type: 'submit' },
	              'Send'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Contact;
	}(_react.Component);
	
	Contact.propTypes = {};
	Contact.defaultProps = {};
	exports.default = Contact;
	
	
	var container = /*#__PURE__*/(0, _reactEmotion.css)();
	var Title = /*#__PURE__*/(0, _reactEmotion2.default)('h1', {
	  target: 'e1umk7190'
	})('color:', function (_ref) {
	  var background = _ref.background;
	  return background || 'inherit';
	}, ';margin:25px auto 0 auto;padding:0 25px 0 25px;max-width:calc(1000px + (25px * 2));@media (min-width:650px){padding:35px 25px 0 25px;}');
	var content = /*#__PURE__*/(0, _reactEmotion.css)('margin:25px auto 0 auto;padding:0 25px 0 25px;max-width:calc(1000px + (25px * 2));display:flex;flex-wrap:wrap;');
	var header = /*#__PURE__*/(0, _reactEmotion.css)('background:black;color:white;margin-bottom:15px;padding:0 5px 2px 5px;font-weight:200;');
	var agency = /*#__PURE__*/(0, _reactEmotion.css)('padding-bottom:15px;a{font-weight:300;}');
	var left = /*#__PURE__*/(0, _reactEmotion.css)('width:100%;padding:0 0 50px 0;@media (min-width:600px){width:50%;padding:0 20px 0 0;}');
	var left__question = /*#__PURE__*/(0, _reactEmotion.css)('margin:0 0 30px 0;padding:0;');
	var right = /*#__PURE__*/(0, _reactEmotion.css)('width:100%;padding:0 0 50px 0;@media (min-width:600px){width:50%;padding:0 0 50px 20px;}');
	var hidden = /*#__PURE__*/(0, _reactEmotion.css)('display:none;visibility:hidden;');
	var thanks = /*#__PURE__*/(0, _reactEmotion.css)('width:100%;');
	
	var query = exports.query = '** extracted graphql fragment **';
	
	function encode(data) {
	  return Object.keys(data).map(function (key) {
	    return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
	  }).join('&');
	}

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-6ddf7164d254c3c3a757.js